export const urlUtils = {
  setPath(path) {
    window.location.href = path;
  },

  getQueryParam(term) {
    if (typeof URLSearchParams !== 'undefined') {
      const queryParams = new URLSearchParams(window.location.search);
      return queryParams.get(term);
    }
    const params = _.fromPairs(
      _.map(window.location.search.slice(1).split('&'), item => {
        if (_.includes(item, '=')) {
          return item.split('=');
        }
        return [item, null];
      }),
    );
    return params[term];
  },
};
